// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";


// import Navbar from '../LandingPage/Navbar';
// import Footer from '../LandingPage/Footer';

// const HighwaysProperties = () => {
//     const location = useLocation();




//     const [categories, setCategories] = useState([]);
//     const [properties, setProperties] = useState([]);
//     const [filtered, setFiltered] = useState([]);

//     const [selectedCategory, setSelectedCategory] = useState("All");
//     const [search, setSearch] = useState("");
//     const [price, setPrice] = useState(10000000);
//     const [maxPrice, setMaxPrice] = useState(10000000);

//     const [highways, setHighways] = useState([]);
//     const [selectedHighway, setSelectedHighway] = useState("All");
//     const [sortOrder, setSortOrder] = useState("default");

//     const [filterOpen, setFilterOpen] = useState(false);

//     /* ---------------- FETCH DATA ---------------- */

//     useEffect(() => {
//         fetchData();
//     }, []);

//     // const fetchData = async () => {

//     //     try {

//     //         const [catRes, propRes] = await Promise.all([
//     //             axios.get("https://api.propertygalleria.in/api/property-categories"),
//     //             axios.get("https://api.propertygalleria.in/master/api/api/owner/properties")
//     //         ]);
//     //         const props = propRes.data.data;
//     //         setCategories(catRes.data);
//     //         // setProperties(propRes.data.data);
//     //         // setFiltered(propRes.data.data);
//     //         setProperties(props);
//     //         setFiltered(props);

//     //         /* GET UNIQUE HIGHWAYS */

//     //         const uniqueHighways = [
//     //             ...new Set(props.map(p => p.zone_desc).filter(Boolean))
//     //         ];

//     //         setHighways(uniqueHighways);

//     //         const highest = Math.max(
//     //             ...props.map(p => parseInt(p.price) || 0)
//     //         );

//     //         setMaxPrice(highest);
//     //         setPrice(highest);


//     //     } catch (err) {
//     //         console.log(err);
//     //     }

//     // };


//     const fetchData = async () => {
//         try {

//             const [catRes, propRes, zoneRes] = await Promise.all([
//                 axios.get("https://api.propertygalleria.in/api/property-categories"),
//                 axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
//                 axios.get("https://api.propertygalleria.in/master/api/api/zones") // 🔥 YOUR API
//             ]);

//             const props = propRes.data.data;

//             setCategories(catRes.data);
//             setProperties(props);
//             setFiltered(props);

//             // ✅ SET HIGHWAYS FROM ZONE API
//             const zoneList = zoneRes.data.map(z => z.zone_desc);

//             setHighways(zoneList);

//             // price logic
//             // const highest = Math.max(
//             //     ...props.map(p => parseInt(p.price) || 0)
//             // );

//             const highest = Math.max(
//                 ...props.map(p => getNumericPrice(p.price))
//             );

//             setMaxPrice(highest);
//             setPrice(highest);

//         } catch (err) {
//             console.log(err);
//         }
//     };

//     console.log('this is highways', highways)

//     //     useEffect(() => {
//     //     if (location.state?.highway) {
//     //         setSelectedHighway(location.state.highway);
//     //     }
//     // }, [location.state]);

//     useEffect(() => {
//         if (location.state?.highway && highways.length > 0) {
//             setSelectedHighway(location.state.highway);
//         }
//     }, [location.state, highways]);

//     const formatPrice = (num) => {

//         if (num >= 10000000) {
//             return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
//         }

//         if (num >= 100000) {
//             return (num / 100000).toFixed(1).replace(".0", "") + "L";
//         }

//         if (num >= 1000) {
//             return (num / 1000).toFixed(1).replace(".0", "") + "K";
//         }

//         return num;
//     };

//     /* ---------------- FILTER LOGIC ---------------- */

//     // useEffect(() => {

//     //     let data = [...properties];

//     //     if (selectedCategory !== "All") {
//     //         data = data.filter(
//     //             p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
//     //         );
//     //     }

//     //     if (search) {
//     //         data = data.filter(
//     //             p => p.title?.toLowerCase().includes(search.toLowerCase())
//     //         );
//     //     }

//     //     data = data.filter(p => parseInt(p.price) <= price);

//     //     setFiltered(data);

//     // }, [selectedCategory, search, price, properties]);


//     useEffect(() => {

//         let data = [...properties];

//         /* CATEGORY FILTER */

//         // if (selectedCategory !== "All") {
//         //     data = data.filter(
//         //         p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
//         //     );
//         // }
//         if (selectedHighway !== "All") {
//             data = data.filter(
//                 p =>
//                     p.zone_desc?.toLowerCase().trim() ===
//                     selectedHighway.toLowerCase().trim()
//             );
//         }
//         /* SEARCH FILTER */

//         if (search) {
//             data = data.filter(
//                 p =>
//                     p.title?.toLowerCase().includes(search.toLowerCase()) ||
//                     p.location?.toLowerCase().includes(search.toLowerCase())
//             );
//         }

//         /* HIGHWAY FILTER */

//         if (selectedHighway !== "All") {
//             data = data.filter(
//                 p =>
//                     // p.zone_desc?.toLowerCase() === selectedHighway.toLowerCase()
//                     p.zone_desc?.toLowerCase().trim() === selectedHighway.toLowerCase().trim()
//             );
//         }

//         /* PRICE FILTER */

//         data = data.filter(
//             p =>
//                 getNumericPrice(p.price) <= price
//             // parseInt(p.price) <= price
//         );

//         /* SORTING */

//         if (sortOrder === "low") {
//             data.sort((a, b) =>
//                 getNumericPrice(a.price) - getNumericPrice(b.price));
//                 //parseInt(a.price) - parseInt(b.price));
//         }

//         // if (sortOrder === "high") {
//         //     data.sort((a, b) => parseInt(b.price) - parseInt(a.price));
//         // }
//         if (sortOrder === "high") {
//     data.sort((a, b) =>
//         getNumericPrice(b.price) - getNumericPrice(a.price)
//     );
// }

//         setFiltered(data);

//     }, [
//         selectedCategory,
//         selectedHighway,
//         search,
//         price,
//         sortOrder,
//         properties
//     ]);


//     const navigate = useNavigate();


//     // const getNumericPrice = (priceStr) => {
//     //     if (!priceStr) return 0;

//     //     const str = priceStr.toUpperCase();

//     //     // ✅ Handle Crores
//     //     if (str.includes("CR")) {
//     //         const num = parseFloat(str);
//     //         return isNaN(num) ? 0 : num * 10000000;
//     //     }

//     //     // ✅ Handle Lakhs (if exists)
//     //     if (str.includes("L")) {
//     //         const num = parseFloat(str);
//     //         return isNaN(num) ? 0 : num * 100000;
//     //     }

//     //     // ✅ Handle normal numbers (PSQ, PSF etc)
//     //     const num = parseFloat(str.replace(/[^\d.]/g, ""));
//     //     return isNaN(num) ? 0 : num;
//     // };

//     const getNumericPrice = (priceStr) => {
//     if (!priceStr) return 0;

//     // ✅ convert to string ALWAYS
//     const str = String(priceStr).toUpperCase();

//     // Crores
//     if (str.includes("CR")) {
//         const num = parseFloat(str);
//         return isNaN(num) ? 0 : num * 10000000;
//     }

//     // Lakhs
//     if (str.includes("L")) {
//         const num = parseFloat(str);
//         return isNaN(num) ? 0 : num * 100000;
//     }

//     // Normal numbers
//     const num = parseFloat(str.replace(/[^\d.]/g, ""));
//     return isNaN(num) ? 0 : num;
// };

//     return (
//         <>

//            <Navbar transparent />
//             {/* <Header /> */}

//             {/* ---------------- CATEGORY SCROLL ---------------- */}

//             <div style={categoryBar}>

//                 <button
//                     style={selectedCategory === "All" ? activeCat : catBtn}
//                     onClick={() => setSelectedCategory("All")}
//                 >
//                     All
//                 </button>

//                 {categories.map(cat => (
//                     <button
//                         key={cat.id}
//                         style={
//                             selectedCategory === cat.category_name
//                                 ? activeCat
//                                 : catBtn
//                         }
//                         onClick={() => setSelectedCategory(cat.category_name)}
//                     >
//                         {cat.category_name}
//                     </button>
//                 ))}

//             </div>



//             {/* ---------------- MAIN LAYOUT ---------------- */}

//             <div style={layout}>


//                 {/* ---------------- LEFT FILTERS ---------------- */}

//                 <div style={filterBox}>

//                     <h3 style={{ marginBottom: 20 }}>Filters</h3>

//                     <label>Search</label>

//                     <input
//                         style={input}
//                         placeholder="Search property..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                     />

//                     <label>Category</label>

//                     <select
//                         style={input}
//                         value={selectedCategory}
//                         onChange={(e) => setSelectedCategory(e.target.value)}
//                     >

//                         <option value="All">All</option>

//                         {categories.map(cat => (
//                             <option key={cat.id}>
//                                 {cat.category_name}
//                             </option>
//                         ))}

//                     </select>

//                     <label>Highway</label>

//                     {/* <select
//                         style={input}
//                         value={selectedHighway}
//                         onChange={(e) => setSelectedHighway(e.target.value)}
//                     >
//                         <option value="All">All</option>

//                         {highways.map((hw, i) => (
//                             <option key={i} value={hw}>
//                                 {hw}
//                             </option>
//                         ))}
//                     </select> */}

//                     <select
//                         style={input}
//                         value={selectedHighway}
//                         onChange={(e) => setSelectedHighway(e.target.value)}
//                     >
//                         <option value="All">All</option>

//                         {highways.map((hw, i) => (
//                             <option key={i} value={hw}>
//                                 {hw}
//                             </option>
//                         ))}
//                     </select>


//                     <label>Price</label>

//                     <input
//                         type="range"
//                         min="0"
//                         max={maxPrice}
//                         value={price}
//                         onChange={(e) => setPrice(Number(e.target.value))}
//                     />

//                     <p>
//                         Max Price : 
//                         {/*  ₹ {formatPrice(price)} */}
//                         {/* ₹ {formatPrice(getNumericPrice(price))} */}
//                         ₹ {formatPrice(price)}
//                     </p>
//                     <label style={{ marginTop: '10px' }}>Sort By Price</label>

//                     <select
//                         style={input}
//                         value={sortOrder}
//                         onChange={(e) => setSortOrder(e.target.value)}
//                     >
//                         <option value="default">Default</option>
//                         <option value="low">Low → High</option>
//                         <option value="high">High → Low</option>
//                     </select>

//                 </div>


//                 {/* ---------------- PROPERTY GRID ---------------- */}

//                 <div style={propertyGrid}>

//                     {filtered.map(p => (

//                         <div key={p.id} style={card}>

//                             <img
//                                 src={p.image || p.property_images?.[0]}
//                                 alt=""
//                                 style={image}
//                                 onClick={() =>
//                                     navigate(`/properties/${p.id}`, {
//                                         state: { property: p }
//                                     })
//                                 }
//                             />

//                             <div style={{ padding: 15 }}>

//                                 <h3>{p.title}</h3>

//                                 <p style={{ color: "#666" }}>
//                                     📍 {p.location}
//                                 </p>

//                                 <div style={priceRow}>
//                                     <span style={{ color: "#2563eb", fontWeight: "bold" }}>
//                                         {/* ₹ {p.price} */} 
//                                         {/* ₹ {formatPrice(p.price)} */}
//                                         ₹ {formatPrice(p.price)}
//                                     </span>


//                                 </div>
//                                 <div>
//                                     <span>{p.area} ACRES</span>
//                                     </div>

//                                 <span style={badge}>
//                                     {p.category}
//                                 </span>

//                             </div>

//                         </div>

//                     ))}

//                 </div>


//             </div>



//  <Footer />
//             {/* <Footer/> */}
//         </>
//     );
// };

// export default HighwaysProperties;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";

// import Navbar from '../LandingPage/Navbar';
// import Footer from '../LandingPage/Footer';

// const HighwaysProperties = () => {

//     const location = useLocation();
//     const navigate = useNavigate();

//     const [categories, setCategories] = useState([]);
//     const [properties, setProperties] = useState([]);
//     const [filtered, setFiltered] = useState([]);

//     const [selectedCategory, setSelectedCategory] = useState("All");
//     const [selectedHighway, setSelectedHighway] = useState("All");

//     const [search, setSearch] = useState("");
//     const [price, setPrice] = useState(10000000);
//     const [maxPrice, setMaxPrice] = useState(10000000);

//     const [highways, setHighways] = useState([]);
//     const [sortOrder, setSortOrder] = useState("default");

//     /* ---------------- SLUG ---------------- */
//     const toSlug = (value = "") =>
//         value.toLowerCase().trim().replace(/\s*\/\s*/g, "-").replace(/\s+/g, "-");

//     /* ---------------- FETCH ---------------- */
//     useEffect(() => {
//         fetchData();
//     }, []);

//     const fetchData = async () => {
//         try {
//             const [catRes, propRes, zoneRes] = await Promise.all([
//                 axios.get("https://api.propertygalleria.in/api/property-categories"),
//                 axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
//                 axios.get("https://api.propertygalleria.in/master/api/api/zones")
//             ]);

//             const props = propRes.data.data;

//             setCategories(catRes.data);
//             setProperties(props);
//             setFiltered(props);

//             setHighways(zoneRes.data.map(z => z.zone_desc));

//             const highest = Math.max(...props.map(p => getNumericPrice(p.price)));
//             setMaxPrice(highest);
//             setPrice(highest);

//         } catch (err) {
//             console.log(err);
//         }
//     };

//     /* ---------------- HIGHWAY FROM NAVIGATION ---------------- */
//     useEffect(() => {
//         if (location.state?.highway && highways.length > 0) {
//             setSelectedHighway(location.state.highway);
//         }
//     }, [location.state, highways]);

//     /* ---------------- PRICE PARSER ---------------- */
//     const getNumericPrice = (priceStr) => {
//         if (!priceStr) return 0;

//         const str = String(priceStr).toUpperCase();

//         if (str.includes("CR")) return parseFloat(str) * 10000000 || 0;
//         if (str.includes("L")) return parseFloat(str) * 100000 || 0;

//         return parseFloat(str.replace(/[^\d.]/g, "")) || 0;
//     };

//     /* ---------------- PRICE FORMAT ---------------- */
//     const formatPrice = (num) => {
//         if (num >= 10000000) return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
//         if (num >= 100000) return (num / 100000).toFixed(1).replace(".0", "") + "L";
//         if (num >= 1000) return (num / 1000).toFixed(1).replace(".0", "") + "K";
//         return num;
//     };

//     /* ---------------- FILTER ---------------- */
//     useEffect(() => {

//         let data = [...properties];

//         /* ✅ CATEGORY */
//         if (selectedCategory !== "All") {
//             data = data.filter(
//                 p => toSlug(p.category) === selectedCategory
//             );
//         }

//         /* ✅ SEARCH */
//         if (search) {
//             data = data.filter(
//                 p =>
//                     p.title?.toLowerCase().includes(search.toLowerCase()) ||
//                     p.location?.toLowerCase().includes(search.toLowerCase())
//             );
//         }

//         /* ✅ HIGHWAY */
//         if (selectedHighway !== "All") {
//             data = data.filter(
//                 p =>
//                     p.zone_desc?.toLowerCase().trim() ===
//                     selectedHighway.toLowerCase().trim()
//             );
//         }

//         /* ✅ PRICE */
//         data = data.filter(
//             p => getNumericPrice(p.price) <= price
//         );

//         /* ✅ SORT */
//         if (sortOrder === "low") {
//             data.sort((a, b) =>
//                 getNumericPrice(a.price) - getNumericPrice(b.price)
//             );
//         }

//         if (sortOrder === "high") {
//             data.sort((a, b) =>
//                 getNumericPrice(b.price) - getNumericPrice(a.price)
//             );
//         }

//         setFiltered(data);

//     }, [selectedCategory, selectedHighway, search, price, sortOrder, properties]);

//     return (
//         <>
//             <Navbar transparent />

//             {/* CATEGORY BAR */}
//             <div style={categoryBar}>

//                 <button
//                     style={selectedCategory === "All" ? activeCat : catBtn}
//                     onClick={() => setSelectedCategory("All")}
//                 >
//                     All
//                 </button>

//                 {categories.map(cat => (
//                     <button
//                         key={cat.id}
//                         style={
//                             selectedCategory === toSlug(cat.category_name)
//                                 ? activeCat
//                                 : catBtn
//                         }
//                         onClick={() =>
//                             setSelectedCategory(toSlug(cat.category_name))
//                         }
//                     >
//                         {cat.category_name}
//                     </button>
//                 ))}
//             </div>

//             {/* MAIN */}
//             <div style={layout}>

//                 {/* FILTER */}
//                 <div style={filterBox}>

//                     <h3>Filters</h3>

//                     <input
//                         style={input}
//                         placeholder="Search..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                     />

//                     {/* CATEGORY */}
//                     <select
//                         style={input}
//                         value={selectedCategory}
//                         onChange={(e) => setSelectedCategory(e.target.value)}
//                     >
//                         <option value="All">All</option>
//                         {categories.map(cat => (
//                             <option
//                                 key={cat.id}
//                                 value={toSlug(cat.category_name)}
//                             >
//                                 {cat.category_name}
//                             </option>
//                         ))}
//                     </select>

//                     {/* HIGHWAY */}
//                     <select
//                         style={input}
//                         value={selectedHighway}
//                         onChange={(e) => setSelectedHighway(e.target.value)}
//                     >
//                         <option value="All">All</option>
//                         {highways.map((hw, i) => (
//                             <option key={i} value={hw}>{hw}</option>
//                         ))}
//                     </select>

//                     {/* PRICE */}
//                     <input
//                         type="range"
//                         min="0"
//                         max={maxPrice}
//                         value={price}
//                         onChange={(e) => setPrice(Number(e.target.value))}
//                     />

//                     <p>Max Price : ₹ {formatPrice(price)}</p>

//                     {/* SORT */}
//                     <select
//                         style={input}
//                         value={sortOrder}
//                         onChange={(e) => setSortOrder(e.target.value)}
//                     >
//                         <option value="default">Default</option>
//                         <option value="low">Low → High</option>
//                         <option value="high">High → Low</option>
//                     </select>

//                 </div>

//                 {/* GRID */}
//                 <div style={propertyGrid}>

//                     {filtered.map(p => (
//                         <div key={p.id} style={card}>

//                             <img
//                                 src={p.image || p.property_images?.[0]}
//                                 alt=""
//                                 style={image}
//                                 onClick={() =>
//                                     navigate(`/properties/${p.id}`, {
//                                         state: { property: p }
//                                     })
//                                 }
//                             />

//                             <div style={{ padding: 15 }}>
//                                 <h3>{p.title}</h3>
//                                 <p>📍 {p.location}</p>

//                                 <div style={priceRow}>
//                                     <span style={{ color: "#2563eb", fontWeight: "bold" }}>
//                                         ₹ {formatPrice(getNumericPrice(p.price))}
//                                     </span>
//                                 </div>

//                                 <div>{p.area} ACRES</div>

//                                 <span style={badge}>{p.category}</span>
//                             </div>

//                         </div>
//                     ))}

//                 </div>
//             </div>

//             <Footer />
//         </>
//     );
// };

// export default HighwaysProperties;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

import Navbar from '../LandingPage/Navbar';
import Footer from '../LandingPage/Footer';

const HighwaysProperties = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [properties, setProperties] = useState([]);
    const [filtered, setFiltered] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedHighway, setSelectedHighway] = useState("All");

    const [search, setSearch] = useState("");
    const [price, setPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);

    const [highways, setHighways] = useState([]);
    const [sortOrder, setSortOrder] = useState("default");


    const [layoutApprovals, setLayoutApprovals] = useState([]);
    const [selectedLayoutApproval, setSelectedLayoutApproval] = useState("All");

    const [selectedNearby, setSelectedNearby] = useState("All");
    const [selectedPropertyType, setSelectedPropertyType] = useState("All");

    const nearbyOptions = [
        "IRR Inner Ring Road",
        "ORR Outer Ring Road",
        "RRR Regional Ring Road"
    ];

    const propertyTypeOptions = [
        "Open Plots/Villa Plots",
        "Flats",
        "Villas",
        "Farm Land",
        "Houses"
    ];


    /* ---------- SLUG ---------- */
    const toSlug = (value = "") =>
        value.toLowerCase().trim().replace(/\s*\/\s*/g, "-").replace(/\s+/g, "-");

    /* ---------- PRICE PARSER (USE EVERYWHERE) ---------- */
    const getNumericPrice = (priceStr) => {
        if (!priceStr) return 0;

        const str = String(priceStr).toUpperCase();

        if (str.includes("CR")) return (parseFloat(str) || 0) * 10000000;
        if (str.includes("L")) return (parseFloat(str) || 0) * 100000;

        return parseFloat(str.replace(/[^\d.]/g, "")) || 0;
    };

    /* ---------- FORMAT ---------- */
    const formatPrice = (num) => {
        if (num >= 10000000) return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
        if (num >= 100000) return (num / 100000).toFixed(1).replace(".0", "") + "L";
        if (num >= 1000) return (num / 1000).toFixed(1).replace(".0", "") + "K";
        return num;
    };

    /* ---------- FETCH ---------- */
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const [catRes, propRes, zoneRes, layoutRes] = await Promise.all([
                axios.get("https://api.propertygalleria.in/api/property-categories"),
                axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
                axios.get("https://api.propertygalleria.in/master/api/api/zones"),
                axios.get("https://api.propertygalleria.in/master/api/api/layout-approvals")

            ]);

            const props = propRes.data.data;

            setCategories(catRes.data);
            setProperties(props);
            setFiltered(props);

            setHighways(zoneRes.data.map(z => z.zone_desc));
            setLayoutApprovals(layoutRes.data.data);
            // ✅ CORRECT MAX PRICE
            const highest = Math.max(...props.map(p => getNumericPrice(p.price)));

            setMaxPrice(highest);
            setPrice(highest);

        } catch (err) {
            console.log(err);
        }
    };

    /* ---------- SET HIGHWAY FROM NAV ---------- */
    useEffect(() => {
        if (location.state?.highway && highways.length > 0) {
            setSelectedHighway(location.state.highway);
        }
    }, [location.state, highways]);

    /* ---------- FILTER ---------- */
    useEffect(() => {

        let data = [...properties];

        if (selectedCategory !== "All") {
            data = data.filter(
                p => toSlug(p.category) === selectedCategory
            );
        }

        if (search) {
            data = data.filter(
                p =>
                    p.title?.toLowerCase().includes(search.toLowerCase()) ||
                    p.location?.toLowerCase().includes(search.toLowerCase())
            );
        }

        if (selectedHighway !== "All") {
            data = data.filter(
                p =>
                    p.zone_desc?.toLowerCase().trim() ===
                    selectedHighway.toLowerCase().trim()
            );
        }
        /* NEARBY FILTER */
        if (selectedNearby !== "All") {
            data = data.filter(
                p =>
                    p.nearby?.toLowerCase().trim() ===
                    selectedNearby.toLowerCase().trim()
            );
        }

        /* LAYOUT APPROVAL */
        if (selectedLayoutApproval !== "All") {
            data = data.filter(
                p =>
                    p.layout_approval?.toLowerCase().trim() ===
                    selectedLayoutApproval.toLowerCase().trim()
            );
        }

        /* PROPERTY TYPE FILTER */
        if (selectedPropertyType !== "All") {
            data = data.filter(
                p =>
                    p.property_type?.toLowerCase().trim() ===
                    selectedPropertyType.toLowerCase().trim()
            );
        }

        // ✅ USE SAME PRICE LOGIC
        data = data.filter(
            p => getNumericPrice(p.price) <= price
        );

        if (sortOrder === "low") {
            data.sort((a, b) =>
                getNumericPrice(a.price) - getNumericPrice(b.price)
            );
        }

        if (sortOrder === "high") {
            data.sort((a, b) =>
                getNumericPrice(b.price) - getNumericPrice(a.price)
            );
        }

        setFiltered(data);

        // }, [selectedCategory, selectedHighway, search, price, sortOrder, properties]);
        // }, [selectedCategory, selectedHighway, selectedLayoutApproval, search, price, sortOrder, properties]);

    }, [
        selectedCategory,
        selectedHighway,
        selectedNearby,
        selectedPropertyType,
        selectedLayoutApproval,
        search,
        price,
        sortOrder,
        properties
    ]);
    return (
        <>
            <Navbar transparent />

            {/* CATEGORY */}
            <div style={categoryBar}>
                <button
                    style={selectedCategory === "All" ? activeCat : catBtn}
                    onClick={() => setSelectedCategory("All")}
                >
                    All
                </button>

                {categories.map(cat => (
                    <button
                        key={cat.id}
                        style={
                            selectedCategory === toSlug(cat.category_name)
                                ? activeCat
                                : catBtn
                        }
                        onClick={() => setSelectedCategory(toSlug(cat.category_name))}
                    >
                        {cat.category_name}
                    </button>
                ))}
            </div>

            {/* MAIN */}
            <div style={layout}>

                {/* FILTER */}
                <div style={filterBox}>

                    <h3>Filters</h3>

                    <input
                        style={input}
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <select
                        style={input}
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        <option value="All">All</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={toSlug(cat.category_name)}>
                                {cat.category_name}
                            </option>
                        ))}
                    </select>

                    <select
                        style={input}
                        value={selectedHighway}
                        onChange={(e) => setSelectedHighway(e.target.value)}
                    >
                        <option value="All">All</option>
                        {highways.map((hw, i) => (
                            <option key={i} value={hw}>{hw}</option>
                        ))}
                    </select>
                    {/* NEAR BY */}
                    <select
                        style={input}
                        value={selectedNearby}
                        onChange={(e) => setSelectedNearby(e.target.value)}
                    >
                        <option value="All">Select Ring Road</option>

                        <option value="IRR Inner Ring Road">
                            IRR Inner Ring Road
                        </option>

                        <option value="ORR Outer Ring Road">
                            ORR Outer Ring Road
                        </option>

                        <option value="RRR Regional Ring Road">
                            RRR Regional Ring Road
                        </option>
                    </select>
                    {/* PROPERTY TYPE */}
                    <select
                        style={input}
                        value={selectedPropertyType}
                        onChange={(e) => setSelectedPropertyType(e.target.value)}
                    >
                        <option value="All">Select Property Type</option>

                        <option value="Open Plots/Villa Plots">
                            Open Plots/Villa Plots
                        </option>

                        <option value="Flats">
                            Flats
                        </option>

                        <option value="Villas">
                            Villas
                        </option>

                        <option value="Farm Land">
                            Farm Land
                        </option>

                        <option value="Houses">
                            Houses
                        </option>
                    </select>
                    {/* LAYOUT APPROVAL */}
                    <select
                        style={input}
                        value={selectedLayoutApproval}
                        onChange={(e) => setSelectedLayoutApproval(e.target.value)}
                    >
                        <option value="All">All Layouts</option>

                        {layoutApprovals.map((layout) => (
                            <option
                                key={layout.id}
                                value={layout.approval_name}
                            >
                                {layout.approval_name}
                            </option>
                        ))}
                    </select>
                    <input
                        type="range"
                        min="0"
                        max={maxPrice}
                        value={price}
                        onChange={(e) => setPrice(Number(e.target.value))}
                    />

                    {/* ✅ FIXED DISPLAY */}
                    <p>Max Price : ₹ {formatPrice(price)}</p>

                    <select
                        style={input}
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="default">Default</option>
                        <option value="low">Low → High</option>
                        <option value="high">High → Low</option>
                    </select>

                </div>

                {/* GRID */}
                <div style={propertyGrid}>
                    {filtered.map(p => (
                        <div key={p.id} style={card}>

                            <img
                                src={p.image || p.property_images?.[0]}
                                alt=""
                                style={image}
                                onClick={() =>
                                    navigate(`/properties/${p.id}`, {
                                        state: { property: p }
                                    })
                                }
                            />

                            <div style={{ padding: 15 }}>
                                <h3>{p.title}</h3>
                                <p>📍 {p.location}</p>

                                <div style={priceRow}>
                                    <span style={{ color: "#2563eb", fontWeight: "bold" }}>
                                        ₹ {formatPrice(getNumericPrice(p.price))}
                                    </span>
                                </div>

                                <div>{p.area} ACRES</div>
                                <span style={badge}>{p.category}</span>
                            </div>

                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </>
    );
};

export default HighwaysProperties;
/* ---------------- STYLES ---------------- */

const layout = {
    display: "flex",
    gap: 30,
    padding: "30px",
    alignItems: "flex-start"
};

const filterBox = {
    width: "260px",
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
    position: "sticky",
    top: 100
};

const propertyGrid = {
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))",
    gap: 20
};

const card = {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    transition: "0.3s"
};

const image = {
    width: "100%",
    height: 180,
    objectFit: "contain"
};

const categoryBar = {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    padding: "20px 30px",
    borderBottom: "1px solid #eee",
    marginTop: '9%',
};

const catBtn = {
    padding: "8px 18px",
    borderRadius: 20,
    border: "1px solid #ddd",
    background: "#fff",
    cursor: "pointer",
    whiteSpace: "nowrap"
};

const activeCat = {
    ...catBtn,
    background: "#2563eb",
    color: "#fff",
    border: "none"
};

const input = {
    width: "100%",
    padding: "10px",
    marginTop: 5,
    marginBottom: 15,
    borderRadius: 8,
    border: "1px solid #ddd"
};

const priceRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10
};

const badge = {
    marginTop: 10,
    display: "inline-block",
    background: "#e0ecff",
    color: "#2563eb",
    padding: "6px 12px",
    borderRadius: 20,
    fontSize: 12
};